const cookiePaths = { 'auth.uberToken': { name: 'ubertoken' } };

export default cookiePaths;
